export const initalPolicies = {
  cancellationRule: [
    { chargeType: "Flexible", daysBeforeCheckin: 0, chargePercentage: 0 },
  ],
  childrenRule: { maxAge: 0, freeStay: true, additionalChildCharge: 0 },
  childrenAgeRule: { maxAge: 0, extraPrice: 0, freeAge: 0 },
};
